<template>
  <div>
    <p>Hier kannst du sehen, wie und ob die Geräte miteinander verbunden sind.</p>
    <ul class="text-left pl-0">
      <li
        v-for="type in types" :key="type.icon"
        class="d-flex align-center mb-3"
      >
        <v-icon small class="mr-3">{{type.icon}}</v-icon>
        <div>
          {{type.title}}<br>
          <small>{{type.description}}</small>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {switchRoom} from './step-utils';


  const component = {
    name: 'StepConnection',

    data: () => ({
      types: [
        {
          title: 'Direkt verbunden',
          icon: 'far fa-network-wired',
          description: 'Geräte haben eine direkte Verbindung, d.h. alle Daten werden direkt ohne jegliche Server dazwischen ausgetauscht.'
        },
        {
          title: 'Über Server verbunden',
          icon: 'far fa-cloud-upload',
          description: 'Die Verbindung wurde über unseren Server aufgebaut, da sich die Geräte nicht direkt finden konnten. Die Daten werden nur über den Server geleitet - d.h. es wird nichts auf unseren Servern zwischengespeichert.'
        },
        {
          title: 'Nicht verbunden',
          icon: 'far fa-unlink',
          description: 'Es konnte keine Verbindung zwischen den Geräte aufgebaut werden.'
        }
      ]
    })
  };


  export const StepConnection = {
    before: async () => {
      await switchRoom('local');
      Vue.store.commit('share/updateTour', {examplePeer: true});
    },
    after: () => Vue.store.commit('share/updateTour', {examplePeer: false}),
    target: '[peer-id="example"] .candidate-type',
    header: 'Verbindungsstatus',
    content: component
  };


  export default component;
</script>

<style scoped>
  ul {
    list-style: none;
  }

  li {
    line-height: 1.2;
  }

  li:last-child {
    margin-bottom: 0 !important;
  }

  .v-icon {
    min-width: 20px;
  }
</style>
